import axios from '@/http/axios/index.js'

export default {
    getVendors(data) {
        return axios.get('vendors-internal/list', { params: data })
    },
    getTypes() {
        return axios.get('vendors-internal/get-types')
    },
    addVendor(data) {
        return axios.post('vendors-internal/add', data)
    },
    lock(data) {
        return axios.post('vendors-internal/lock', data)
    },
   
}
